// extracted by mini-css-extract-plugin
export default {"home":"HomePage_home__9PFRw"};